import React from 'react'
import { Row, Col, Form, Input, Checkbox } from 'antd'
import { useTranslation } from 'react-i18next'
import { capitalize } from 'lodash'

const BottomSection = props => {
  const {
    form: { getFieldDecorator },
    label,
    description,
    outline,
    objectives,
    shareProfile,
    marketplaceDescription,
    onDescription,
    onObjectives,
    onOutline,
    onShareProfile,
    onMarketPlaceDescription,
    isMarketPlace
  } = props

  const { t } = useTranslation()

  const handleDescription = (val, field) => {
    switch (field) {
      case 'description':
        onDescription(val)
        break
      case 'objectives':
        onObjectives(val)
        break
      case 'outline':
        onOutline(val)
        break
      case 'marketplaceDescription':
        onMarketPlaceDescription(val)
        break
      default:
        break
    }
  }

  const generateEditor = (title, params, description) => {
    return (
      <div className="margin_top ">
        <Form.Item
          label={t('labels:description')}
          colon={false}
          required={false}
        >
          {getFieldDecorator(
            params === 'marketplaceDescription'
              ? 'Marketplace Description'
              : capitalize(params),
            {
              rules: [
                {
                  required: params === 'description' ? false : true
                }
              ],
              initialValue: description
            }
          )(
            <Input.TextArea
              placeholder={t('v4:text')}
              autoSize={{ minRows: 5, maxRows: 20 }}
              onKeyDown={e => {
                if (
                  e.keyCode === 32 &&
                  (e.target.value.charAt(e.target.selectionStart - 1) === ' ' ||
                    e.target.value.charAt(e.target.selectionStart) === ' ')
                ) {
                  e.preventDefault()
                }
              }}
              onChange={e => handleDescription(e.target.value, params)}
              style={{ fontSize: '1.6rem', resize: 'none' }}
              wrap={'soft'}
            />
          )}
        </Form.Item>
      </div>
    )
  }
  return (
    <div style={{ width: '100%' }}>
      <Row className="quill-div_row">
        <Col span={24}>
          {isMarketPlace && (
            <>
              {generateEditor(label + ' Objectives', 'objectives', objectives)}
              {generateEditor(label + ' Outline', 'outline', outline)}
              {generateEditor(
                'Description',
                'marketplaceDescription',
                marketplaceDescription
              )}
            </>
          )}
          {!isMarketPlace &&
            generateEditor('Description', 'description', description)}
        </Col>
      </Row>
      {isMarketPlace && (
        <Form.Item colon={false} required={false}>
          {getFieldDecorator('is_shared_profile', {
            valuePropName: 'checked',
            initialValue: shareProfile
          })(
            <Checkbox
              className="marketplace__checkbox"
              onChange={e => onShareProfile(e.target.checked)}
            >
              {t('v3:allow_sharing_trainer_info')}
            </Checkbox>
          )}
        </Form.Item>
      )}
    </div>
  )
}

export default BottomSection
